import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  quickPayDesign: false,
  quickPayRequest: [],
  quickPayTemplate: '',
  quickPayPageActiveButton: {
    name: "QuickPay",
  },
  quickPayList: [],
  uploadNewBaseSalaryData: {
    quickPayDetailsList: [],
    TotalEmployees: 0,
    TotalEligible: 0,
    TotalMismatch: 0,
    TotalError: 0,
  },
  selectedQuickPayDetails: {
    identifier: null,
    status: null,
  },
  quickPayDetails: [],
  checkerAdvanceId: 0,
  quickPayReduxList: {
    list: [],
    status: ""
  },
  createQuickPayRequest: {},
  showQuickPayDetails: false,
  editedRecords: {}, 
};

const quickPaySlice = createSlice({
  name: "quickPay",
  initialState,
  reducers: {
    setQuickPayDesign: (state, action) => {
      state.quickPayDesign = action.payload;
    },
    setNewPushQuickPayStatus: (state, action) => {
      state.newPushQuickPayStatus = action.payload;
    },
    setQuickPayTemplate: (state, action) => {
      state.quickPayTemplate = action.payload;
    },
    setQuickPayList: (state, action) => {
      state.quickPayList = action.payload;
    },
    setCreateQuickPayRequest: (state, action) => {
      state.createQuickPayRequest = action.payload;
    },
    setQuickPayPageActiveButton: (state, action) => {
      state.quickPayPageActiveButton = action.payload;
    },
    setQuickPayRequest: (state, action) => {
      state.quickPayRequest = action.payload;
    },
    setUploadNewBaseSalaryData: (state, action) => {
      state.uploadNewBaseSalaryData = action.payload;
    },
    setQuickPayCheckerAdvanceId: (state, action) => {
      state.checkerAdvanceId = action.payload
    },
    updateQuickPayDetailStatus: (state, action) => {
      const { index, newStatus } = action.payload;
      let detail = state.uploadNewBaseSalaryData.quickPayDetailsList[index];
      if (detail) {
        detail.Status = newStatus;
      }
    },
    updateQuickPayRecord(state, action) {
      const { rowIndex, field, value } = action.payload;
      const updatedQuickPayDetails = [...state.quickPayDetails];
      const editedRecords = { ...state.editedRecords };

      if (!editedRecords[rowIndex]) {
        editedRecords[rowIndex] = { ...updatedQuickPayDetails[rowIndex] };  
      }

      // Update the value in editedRecords
      editedRecords[rowIndex][field] = value;

      state.editedRecords = editedRecords;
    },
    saveQuickPayRecord(state, action) {
      const { rowIndex, updatedValues } = action.payload;
      const updatedQuickPayDetails = [...state.quickPayDetails];

      updatedQuickPayDetails[rowIndex] = {
        ...updatedQuickPayDetails[rowIndex],
        ...updatedValues,
      };

      state.quickPayDetails = updatedQuickPayDetails;
      delete state.editedRecords[rowIndex]; 
    },

    setSelectedQuickPayDetails: (state, action) => {
      state.selectedQuickPayDetails = action.payload;
    },
    setQuickPayDetails: (state, action) => {
      state.quickPayDetails = action.payload;
    },
    setQuickPayReduxList: (state, action) => {
      state.quickPayReduxList = action.payload;
    },
    updatePayrollDetails: (state, action) => {
      const { id, payrollAmount, startDate } = action.payload;
      const index = state.quickPayList.findIndex((item) => item.id === id);
      if (index !== -1) {
        state.quickPayList[index].PayrollAmount = payrollAmount;
        state.quickPayList[index].StartDate = startDate;
      }
    },
    setShowQuickPayDetails: (state, action) => {
      state.showQuickPayDetails = action.payload;
    },
  },
});

export const {
  setQuickPayDesign,
  setQuickPayPageActiveButton,
  setQuickPayRequest,
  setQuickPayList,
  setUploadNewBaseSalaryData,
  setQuickPayLoading,
  updateQuickPayDetailStatus,
  setSelectedQuickPayDetails,
  setQuickPayDetails,
  setQuickPayReduxList,
  updatePayrollDetails,
  setCreateQuickPayRequest,
  setNewPushQuickPayStatus,
  setShowQuickPayDetails,
  setQuickPayCheckerAdvanceId,
  setQuickPayTemplate
} = quickPaySlice.actions;
export default quickPaySlice.reducer;
